// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608240117/js/" + chunkId + "." + {"44":"85f0d1f9","225":"798e8b88","481":"c6b92348","486":"4b52c9a8","770":"27814fdd"}[chunkId] + ".0.5446790663646607.chunk.js";
};